import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { faqs } from '../data/toolkit';

const { FiPlus, FiMinus } = FiIcons;

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="faq section">
      <div className="shell faq-layout">
        <div>
          <p className="eyebrow">Questions, answered plainly</p>
          <h2>Before you buy.</h2>
        </div>
        <div className="faq-list">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div className="faq-item" key={item.question}>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                >
                  <span>{item.question}</span>
                  <SafeIcon icon={isOpen ? FiMinus : FiPlus} aria-hidden="true" />
                </button>
                {isOpen && <p>{item.answer}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FaqSection;